import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ptTranslation from './locales/pt.json';
import enTranslation from './locales/en.json';
import esTranslation from './locales/es.json';

const resources = {
  pt: ptTranslation,
  en: enTranslation,
  es: esTranslation,
};

const HTML_LANG: Record<string, string> = { pt: 'pt-BR', en: 'en', es: 'es' };

// <html lang> acompanha o idioma escolhido (leitores de tela e buscadores leem esse atributo)
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = HTML_LANG[lng.slice(0, 2)] ?? 'pt-BR';
});

// Sem idioma salvo, abre em português. Não usa o idioma do navegador: o Googlebot navega em inglês
// e o site seria indexado em inglês.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

export default i18n;
